var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9C0 4.04857 4.04857 0 9 0C13.9514 0 18 4.04857 18 9C18 13.9514 13.9514 18 9 18C4.04857 18 0 13.9514 0 9ZM9 1.25581C4.74213 1.25581 1.25581 4.74213 1.25581 9C1.25581 13.2579 4.74213 16.7442 9 16.7442C13.2579 16.7442 16.7442 13.2579 16.7442 9C16.7442 4.74213 13.2579 1.25581 9 1.25581Z",
    fill: "#C6343E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8144 6.18586C12.0596 6.43108 12.0596 6.82864 11.8144 7.07386L7.07581 11.8125C6.8306 12.0577 6.43303 12.0577 6.18782 11.8125C5.9426 11.5672 5.9426 11.1697 6.18782 10.9245L10.9264 6.18586C11.1716 5.94065 11.5692 5.94065 11.8144 6.18586Z",
    fill: "#C6343E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.18782 6.18586C6.43303 5.94065 6.8306 5.94065 7.07581 6.18586L11.8144 10.9245C12.0596 11.1697 12.0596 11.5672 11.8144 11.8125C11.5692 12.0577 11.1716 12.0577 10.9264 11.8125L6.18782 7.07386C5.9426 6.82864 5.9426 6.43108 6.18782 6.18586Z",
    fill: "#C6343E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.2264cf39d5b4393feb85824d3da14eac.svg";
export { ForwardRef as ReactComponent };